import { defineComponent as o, computed as n, openBlock as s, createElementBlock as l, normalizeClass as m, createBlock as b, resolveDynamicComponent as u, toRaw as g, createCommentVNode as x, createElementVNode as f, toDisplayString as p } from "vue";
import { tw as t } from "../../utils/tailwind.js";
const h = ["title"], y = { class: "min-w-0 truncate" }, z = /* @__PURE__ */ o({
  name: "RevTag",
  __name: "Tag",
  props: {
    icon: {},
    label: {},
    size: { default: "medium" },
    variant: {},
    variation: { default: "filled" }
  },
  setup(e) {
    const r = n(() => ({ small: "16", medium: "16", large: "20" })[e.size]), d = n(() => {
      const a = t`rounded-xs inline-flex items-center max-w-full`, i = {
        filled: {
          small: t`caption-bold gap-2 px-2 py-0`,
          medium: t`body-2-bold gap-2 px-4 py-0`,
          large: t`body-1-bold gap-2 px-4 py-0`
        },
        // line-height is customized to make sure the text is correctly aligned if a filled & outline variation
        // are on the same line
        outline: {
          small: t`caption-bold gap-2 px-2 py-0 leading-[14px]`,
          medium: t`body-2-bold gap-2 px-4 py-0 leading-[18px]`,
          large: t`body-1-bold gap-2 px-4 py-0 leading-[22px]`
        }
      }, c = {
        filled: {
          primary: t`bg-static-brand-hi text-static-default-hi`,
          secondary: t`bg-static-default-mid text-static-default-hi`,
          info: t`bg-static-info-mid text-static-info-hi`,
          success: t`bg-static-success-mid text-static-success-hi`,
          warning: t`bg-static-warning-mid text-static-warning-hi`,
          danger: t`bg-static-danger-mid text-static-danger-hi`,
          alternate: t`bg-static-brand-mid text-static-brand-hi`
        },
        outline: {
          primary: t`border-static-brand-hi text-static-default-hi border`,
          secondary: t`border-static-default-mid text-static-default-hi border`,
          info: t`border-static-info-mid text-static-info-hi border`,
          success: t`border-static-success-mid text-static-success-hi border`,
          warning: t`border-static-warning-mid text-static-warning-hi border`,
          danger: t`border-static-danger-mid text-static-danger-hi border`,
          alternate: t`border-static-brand-mid text-static-brand-hi border`
        }
      };
      return [a, i[e.variation][e.size], c[e.variation][e.variant]];
    });
    return (a, i) => (s(), l("span", {
      class: m(d.value),
      title: e.label
    }, [
      e.icon ? (s(), b(u(g(e.icon)), {
        key: 0,
        size: r.value,
        "aria-hidden": "true",
        class: "shrink-0"
      }, null, 8, ["size"])) : x("", !0),
      f("span", y, p(e.label), 1)
    ], 10, h));
  }
});
export {
  z as default
};
